import cx from 'classnames';

import LightBulb from './LightBulb.svg';

import styles from './proTip.module.less';

export type ProTipProps = {
  className?: string | { [className: string]: boolean };
  children: React.ReactNode;
};

export const ProTip: React.FC<ProTipProps> = (props) => {
  const { children, className } = props;
  return (
    <div className={cx(styles.tip, className)}>
      <img src={LightBulb} alt="" className={styles.tipIcon} />
      <span className={styles.tipPrefix}>Pro Tip: </span>
      <span> {children} </span>
    </div>
  );
};

export default ProTip;
